import { Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { format } from "date-fns";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addHolidays, getHolidays } from "redux/modules/holidaySlice";
import ConfigSmartServiceService from "services/ConfigSmartServiceService";
import DatetimeService from "services/DatetimeService";
import * as yup from "yup";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { get } from "lodash";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(a, b, c) {
  return { a, b, c };
}


const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50
  },
  warpButton: {
    marginTop: 30,
    display: 'flex',
    justifyContent: 'space-between',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30
  },
  warpTabs: {
    marginTop: 30
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: '#F1F3F9',
    color: '#8898AA'
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: '#00D0FF',
    marginRight: 10
  },
  warpButtonDetail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonStatusDetail: {

    backgroundColor: 'white',
    padding: 5,
    borderRadius: '50%',
    boxShadow: '0px 0px 2px 2px rgba(23, 43, 77, 0.2)'
  },
  warpData: {
    marginTop: 20
  },
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: '#1094D8',
    color: 'white'
  },
  iconStatus: {
    color: '#2DCE98',
    marginRight: 5
  },
  warpButtonSave: {
    textAlign: 'right',
    marginTop: 30
  },
  buttonSave: {
    marginLeft: 5,
    width: 120
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  wrapDateControl: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    marginBottom: 15
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  dateControl: {
    marginRight: 5,
    width: '100%'
  },
  btnEdit: {
    color: 'white',
    backgroundColor: '#2DCE98',
    marginLeft: 10
  },
  btnRemove: {
    color: 'white',
    backgroundColor: '#F53C56',
    marginLeft: 10
  },
  warpRowDialog: {
    marginTop: 10
  },
  dtitle: {
    color: '#40B8D4',
  },
  d2title: {
    color: '#172B4D',
    paddingBottom: 10

  },
  textDialog: {
    width: '100%',
  },
  warpDialog: {
    padding: "30px", minWidth: "600px", minHeight: "200px"
  },
}));



function ConfigSmartServicedPage() {
  const { t, i18n } = useTranslation();


  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const [date, setDate] = React.useState(new Date());
  const [dialogData, setDialogData] = React.useState(false);
  const [Data, setData] = React.useState([]);
  const masterData = useSelector(selectMasterData);
  const smartservices = get(masterData, "smartservice", []);
  const department = get(masterData, "department", []);


  useEffect(async () => {

    async function mergedFetchData() {
      await dispatch(
        getMasterData({
          smartservice: true,
          department: true,
        })
      );
      await getConfigSmartServices();


    }
    mergedFetchData();


  }, []);


  const handleAddConfigSmartService = async () => {
    setDialogData({
      consmartdepId: null,
      departmentId: null,
      smartserviceId: null
    })
    setOpen(true);
  }


  const getConfigSmartServices = async () => {

    const res = await ConfigSmartServiceService.getConfigSmartService(null);
    if (res.status) {
      setData(res.results);
    }
  }

  const handleClose = async (config) => {

    if (config) {
      const body = {
        list: [
          {
            consmartdepId: config.consmartdepId,
            smartserviceId: config.smartserviceId,
            departmentId: config.departmentId,
            status: config.status,
          }
        ]
      }

      const res = await ConfigSmartServiceService.addConfigSmartService(body);
      await getConfigSmartServices();
    }
    setOpen(false);
  };


  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="หน่วยงานรับรอง" />
      {
        open &&
        <HolidayDialog data={dialogData} open={open} onClose={handleClose} department={department} smartservice={smartservices} />
      }
      <div className={classes.warpSubHeader} >
        <AdminTitle2 subTitle="ตั้งค่าหน่วยงานรับรอง" />
        <div className={classes.wrapDateControl}>

          <Button variant="contained" size="medium" color="primary" onClick={() =>
            handleAddConfigSmartService()} className={classes.buttonDialogSave}>
            <AddIcon />
            เพิ่มหน่วยงานรับรอง
          </Button>
        </div>

      </div >

      <div className={classes.warpData}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead >
              <TableRow>
                <StyledTableCell className={classes.tableHead} style={{ 'width': 200 }}>ประเภทวีซ่า</StyledTableCell>
                <StyledTableCell className={classes.tableHead} >หน่วยงานรับรอง</StyledTableCell>

                <StyledTableCell className={classes.tableHead} style={{ 'width': 200, textAlign: 'center' }}>จัดการ</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Data.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell style={{ 'width': 200 }}>{row?.smartserviceName}</StyledTableCell>
                  <StyledTableCell >{row?.departmentName}</StyledTableCell>


                  <StyledTableCell style={{ 'width': 200, textAlign: 'center' }}>
                    <div className={classes.warpButtonDetail}>
                      <Button size="small" color="primary" className={classes.btnEdit} onClick={async () => {

                        setDialogData({
                          consmartdepId: row?.consmartdepId,
                          departmentId: row?.departmentId,
                          smartserviceId: row?.smartserviceId
                        })
                        setOpen(true);
                      }}>
                        แก้ไข
                      </Button>
                      <Button size="small" color="error" className={classes.btnRemove} onClick={async () => {

                        if (!window.confirm('Do you want to delete this config?')) { return; }
                        handleClose({
                          consmartdepId: row?.consmartdepId,
                          departmentId: row?.departmentId,
                          smartserviceId: row?.smartserviceId,
                          status: false
                        })
                      }}>
                        ลบ
                      </Button>
                    </div>
                  </StyledTableCell>

                </StyledTableRow>
              ))}

            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Paper>
  );
}

export default ConfigSmartServicedPage;



function HolidayDialog(props) {
  const useStylesHoliday = makeStyles((theme) => ({

    warpRowDialog: {
      marginTop: 10
    },
    dtitle: {
      color: '#40B8D4',
    },
    d2title: {
      color: '#172B4D',
      paddingBottom: 10

    },
    textDialog: {
      width: '100%',
    },
    warpDialog: {
      padding: "30px", minWidth: "600px", minHeight: "200px"
    },
    formControl: {
      width: '100%'
    },
    warpFormControl: {
      paddingLeft: 10,
      paddingRight: 10,
      marginTop: 10
    },
    warpButtonDialogSave: {
      display: 'flex'
    },
    buttonDialogSave: {
      width: '100%',
      margin: '15px 5px'
    },
  }));


  const classes = useStylesHoliday();
  const { onClose, open, data, department, smartservice } = props;




  const validationSchema = yup.object({
    departmentId: yup.string().required("Department is required."),
    smartserviceId: yup.string().required("Visa Type is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      consmartdepId: data?.consmartdepId,
      departmentId: data?.departmentId,
      smartserviceId: data?.smartserviceId,
    },
    onSubmit: async (values) => {

      const body = {
        consmartdepId: values.consmartdepId,
        departmentId: values.departmentId,
        smartserviceId: values.smartserviceId,
        status: true
      };

      onClose(body);
    },
  });


  const handleClose = () => {
    onClose(null);
  };





  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} fullWidth={true} className={classes.warpDialog}>
      <DialogTitle id="simple-dialog-title" className={classes.dtitle}>ตั้งค่าหน่วยงานรับรอง</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.warpRowDialog}>
            <Grid container>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>ประเภทวีซ่า</InputLabel>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    // className={classes.formControl}
                    value={
                      get(formik.values, `smartserviceId`, null) ||
                      null
                    }
                    name="smartserviceId"
                    onChange={formik.handleChange}
                    error={isError("smartserviceId", formik)}
                    helperText={getErrorMessage("smartserviceId", formik)}
                  >
                    {smartservice.map((config) => (
                      <MenuItem
                        key={config.smartserviceId}
                        value={config.smartserviceId}
                      >
                        {config.smartserviceName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} className={classes.warpFormControl}>
                <InputLabel className={classes.d2title}>หน่วยงานรับรองคุณสมบัติ</InputLabel>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    value={
                      get(formik.values, `departmentId`, null) ||
                      null
                    }
                    name="departmentId"
                    onChange={formik.handleChange}

                    error={isError("departmentId", formik)}
                    helperText={getErrorMessage("departmentId", formik)}
                  >
                    {department.map((config) => (
                      <MenuItem
                        key={config.departmentId}
                        value={config.departmentId}
                      >
                        {config.departmentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          <Grid container>
            <Grid item xs={12} md={12} className={classes.warpFormControl}>
              <div className={classes.warpButtonDialogSave}>
                <Button variant="outlined" size="medium" type="button" color="primary" onClick={() => handleClose()} className={classes.buttonDialogSave}>
                  Close
                </Button>
                <Button variant="contained" size="medium" type="submit" color="primary" className={classes.buttonDialogSave}>
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog >
  );
}

